<template>
    <!-- 设备弹框 -->
    <el-dialog
        v-dialogDrag
        class="dispatchOrder_deviceDialog"
        :closeOnClickModal='false'
        :before-close="beforeClose"
        :title="title"
        :visible="visible"
        width="20%">
        <el-form
            class="form-container"
            ref="formRef"
            label-width="100px"
            :model="form"
            :rules="rules"
        >
            <el-form-item label="设备类型：" prop="deviceType">
                <el-select
                    v-model="form.deviceType"
                    :disabled="isEdit"
                    placeholder="设备类型"
                >
                    <el-option
                        v-for="(val, key) in dictData.DEVICETYPE"
                        :key="key"
                        :label="val"
                        :value="key"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="设备号：" prop="deviceNo">
                <el-input
                    v-model.trim="form.deviceNo"
                    placeholder="请输入设备号"
                    clearable
                    :disabled="isEdit"
                ></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer">
            <el-button
                type="primary"
                v-if="isEdit"
                @click="editBtn"
                :loading="loading"
            >
                修 改
            </el-button>
            <el-button
                type="primary"
                v-if="!isEdit"
                @click="bindBtn"
                :loading="loading"
            >
                绑 定
            </el-button>
            <el-button
                type="primary"
                v-if="isEdit"
                @click="unbindBtn"
                :loading="unbindLoading"
            >
                解除绑定
            </el-button>
        </span>
    </el-dialog>
</template>

<script>
import { dictWithUrl } from '@/components/lots/api.js';
import { bindEquipment, cancelEquipment } from '../../../api/performanceDispatchMgmt';
import { getDictionaryDetailByCode } from '../../../api/common';

export default {
    props: {
        row: {
            type: Object,
            default: () => {
                return {};
            }
        },
        visible: {
            type: Boolean,
            default: () => {
                return false;
            }
        }
    },
    data() {
        return {
            form: {
                deviceNo: '',
                deviceType: '10',
                dispatchDeviceOperateType: '',
                dispatchNo: ''
            },
            isEdit: false, // 是否可编辑
            dictData: {}, // 数据字典集合
            title: '设备绑定',
            loading: false,
            unbindLoading: false,
            rules: {
                deviceType: [
                    {
                        required: true,
                        message: '请选择设备类型',
                        trigger: ['blur', 'change']
                    }
                ],
                deviceNo: [
                    {
                        required: true,
                        message: '请输入设备号',
                        trigger: ['blur', 'change']
                    }
                ]
            }
        };
    },
    mounted () {
        this.initData(this.form, this.row);
        this.getDicData();
    },
    methods: {
        beforeClose () {
            this.$emit('refresh');
            this.$emit('update:visible', false);
        },
        // 修改按钮
        editBtn () {
            this.isEdit = false;
        },
        // 绑定 、修改
        bindBtn () {
            this.$refs.formRef.validate(valid => {
                if (valid) {
                    this.loading = true;
                    bindEquipment({
                        deviceNo: this.form.deviceNo,
                        deviceType: this.form.deviceType,
                        dispatchNo: this.row.dispatchNo
                    }).then(res => {
                        if (res && +res.code === 0) {
                            this.$message.success(res.data || '操作成功');
                            this.beforeClose();
                        }
                    }).finally(() => {
                        this.loading = false;
                    });
                }
            });
        },
        // 解除绑定
        unbindBtn () {
            this.$refs.formRef.validate(valid => {
                if (valid) {
                    this.unbindLoading = true;
                    cancelEquipment({
                        deviceNo: this.form.deviceNo,
                        deviceType: this.form.deviceType,
                        dispatchNo: this.row.dispatchNo
                    }).then(res => {
                        if (res && +res.code === 0) {
                            this.$message.success(res.data || '操作成功');
                            this.beforeClose();
                        }
                    }).finally(() => {
                        this.unbindLoading = false;
                    });
                }
            });
        },
        /**
        * @initData 页面初始化
        * @form 页面初始化数据
        * @componentsData 接收的行数据
        */
        initData (form, componentsData) {
            form.dispatchNo = componentsData.dispatchNo;
            // 根据设备绑定状态（0-已绑定，1-未绑定），绑定状态且设备号存在可进行取消、修改操作
            this.isEdit = !!(componentsData.bindingDeviceFlag === 0 && componentsData.deviceNo);
            if (this.isEdit) {
                this.isBind = false;
                this.title = '设备解绑/修改';
                form.deviceNo = componentsData.deviceNo;
                form.deviceType = componentsData.deviceType;
            }
        },
        /**
         * @description 获取数据字典
         * @param {string} 数据字典编码字符串
         * @return {Object} 数据字典类型集合
         */
        async getDicData () {
            const dict = await dictWithUrl(
                'DEVICETYPE'
            );
            this.dictData = dict.data;
        }
    }
};
</script>

<style lang="less">
.dispatchOrder_deviceDialog {
    .el-dialog {
        min-width: 440px;
    }
    .el-select {
        width: 100%;
    }
}
</style>
